import { render, staticRenderFns } from "./LoadingSkeleton.vue?vue&type=template&id=3f023446&scoped=true"
import script from "./LoadingSkeleton.vue?vue&type=script&lang=ts"
export * from "./LoadingSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./LoadingSkeleton.vue?vue&type=style&index=0&id=3f023446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f023446",
  null
  
)

export default component.exports